/**
 * Auth gating for discovery routes (`/search`, `/venue/:slugOrId`): blur, redirect, login modal.
 *
 * Default: **open** (not enforced) so anonymous users can browse search and venue details.
 *
 * To turn blur / redirect / login modal back on, set in `.env` and restart the dev server / redeploy:
 *   REACT_APP_AUTH_GATE_DISCOVERY_ENFORCED=true
 *
 * Other routes using AuthGate (e.g. `/messages`) are unchanged — they always enforce login.
 */

export const isAuthGateDiscoveryEnforced = () =>
  String(process.env.REACT_APP_AUTH_GATE_DISCOVERY_ENFORCED ?? "false").toLowerCase() === "true";
